import React, { Component } from "react";
import { connect } from "react-redux";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import MapWrapper from "./MapContainer/MapWrapper";
import { Chart } from "react-google-charts";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport, getJobPackReport } from "./actions";
import { gridStyle, cellStyle } from "./gridHelper";
import ins_data from "./inspectionData.json";
import aud_data from "./auditData.json";
import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import PrintIcon from "@material-ui/icons/Print";
import "../reports.css";

import styled from "styled-components";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
const MapDiv = styled.div`
    width: 97%;
    height: 300px;
`;
let checkedit = "";
class HD16Inspection extends Component {
    constructor(props) {
        super(props);
        let edit = props.location.pathname.split("/");
        checkedit = edit[1];
        if (props.match.params.subject_name === "reports") {
            this.state = {
                imageModal: false,
                selectedImg: false,
                report: false,
                editing:
                    edit[1] === "report-view"
                        ? false
                        : edit[1] === "report-view-standalone"
                        ? false
                        : true,
                title: document.title,
                prefix:
                    edit[4].replace(/-/g, "_") === "hd16_inspection_report"
                        ? "IM"
                        : "AM",
                reportType: edit[4].replace(/-/g, "_"),
                checks:
                    edit[4].replace(/-/g, "_") === "hd16_inspection_report"
                        ? ins_data
                        : aud_data,
            };
            props.getReport(
                props.match.params.uprn,
                props.match.params.subject_name.replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                edit[4].replace(/-/g, "_")
            );
        } else {
            this.state = {
                imageModal: false,
                selectedImg: false,
                report: false,
                editing:
                    edit[1] === "report-view"
                        ? false
                        : edit[1] === "report-view-standalone"
                        ? false
                        : true,
                title: document.title,
                prefix:
                    edit[7].replace(/-/g, "_") === "hd16_inspection_report"
                        ? "IM"
                        : "AM",
                reportType: edit[7].replace(/-/g, "_"),
                checks:
                    edit[7].replace(/-/g, "_") === "hd16_inspection_report"
                        ? ins_data
                        : aud_data,
            };
            props.getJobPackReport(
                props.match.params.uprn,
                edit[2].replace(/-/g, "_"),
                edit[3],
                edit[4].replace(/-/g, "_"),
                edit[5].replace(/-/g, "_"),
                edit[7].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    style={{ width: "100%", position: "relative" }}
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderInspection = (key, value = false) => {
        let col = "green";
        value === "A"
            ? (col = "green")
            : value === "U"
            ? (col = "red")
            : value === "I"
            ? (col = "orange")
            : (col = "grey");
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                    style={{ minWidth: "100%", background: col }}
                >
                    <MenuItem value={"A"} style={{ background: "green" }}>
                        A
                    </MenuItem>
                    <MenuItem value={"U"} style={{ background: "red" }}>
                        U
                    </MenuItem>
                    <MenuItem value={"I"} style={{ background: "orange" }}>
                        I
                    </MenuItem>
                    <MenuItem value={"N/R"} style={{ background: "grey" }}>
                        N/R
                    </MenuItem>
                </Select>
            );
        } else {
            // return <div style={this.statusStyle(value)}>{value}</div>;

            if (value === "A") {
                return <FiberManualRecordIcon style={{ color: "green" }} />;
            } else if (value === "I") {
                return <FiberManualRecordIcon style={{ color: "#FFBF00" }} />;
            } else if (value === "U") {
                return <FiberManualRecordIcon style={{ color: "red" }} />;
            } else {
                return <FiberManualRecordIcon style={{ color: "grey" }} />;
            }
        }
    };
    renderCarriageWay = (key, value = false) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                    style={{ minWidth: "100%" }}
                >
                    <MenuItem value={"Single"}>Single</MenuItem>
                    <MenuItem value={"Dual Carriageway"}>
                        Dual Carriageway
                    </MenuItem>
                    <MenuItem value={"Motorway"}>Motorway</MenuItem>
                    <MenuItem value={"Climbing Lane"}>Climbing Lane</MenuItem>
                    <MenuItem value={"Minor"}>Minor</MenuItem>
                    <MenuItem value={"Urban Multi-Lane"}>
                        Urban Multi-Lane
                    </MenuItem>
                    <MenuItem value={"Hard Shoulder"}>Hard Shoulder</MenuItem>
                </Select>
            );
        } else {
            return value;
        }
    };
    renderYesNo = (key, value = false) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                    style={{ minWidth: "100%" }}
                >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                </Select>
            );
        } else {
            return value;
        }
    };
    statusStyle = (value) => {
        let color = "black";
        let background = "white";

        if (value === "A") {
            background = "green";
        } else if (value === "I") {
            background = "orange";
        } else if (value === "U") {
            background = "red";
        } else {
            background = "grey";
        }

        return { minWidth: "100%", minHeight: "100%", color, background };
    };
    getTotal = (val) => {
        const { checks, report } = this.state;
        let count = 0;
        Object.keys(checks).map((e) => {
            checks[e].map((f) => {
                if (report[f.key] === val) count++;
                return null;
            });
            return null;
        });
        return count;
    };
    render() {
        // let report = this.props.report === false ? false : this.props.report;
        let rT = this.renderText;
        let rI = this.renderInspection;
        let rC = this.renderCarriageWay;
        let rYN = this.renderYesNo;
        let gstyle = gridStyle;
        let cstyle = cellStyle;
        let noteCount = 3;
        let count = this.getTotal;
        const {
            editing,
            checks,
            reportType,
            report,
            prefix,
            selectedImg,
        } = this.state;
        return editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={
                    reportType === "hd16_inspection_report"
                        ? "TTM Inspection Report"
                        : "TTM Audit Report"
                }
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        {reportType === "hd16_inspection_report"
                            ? "TTM Inspection Report"
                            : "TTM Audit Report"}

                        <ReactToPrint
                            // pageStyle="@page { size: 2.5in 4in}"
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                                document.title =
                                    "TTM Inspection - " +
                                    this.props.match.params.report_id
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {
                                document.title = this.state.title;
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && <this.props.header />}
                            <div
                                className="imgDiv"
                                style={{
                                    float: "left",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography variant="h5">
                                    TTM{" "}
                                    {reportType === "hd16_inspection_report"
                                        ? "Inspection"
                                        : "Audit"}{" "}
                                    Report
                                </Typography>
                            </div>
                            <div style={{ width: "100%" }}>
                                <div
                                    style={{
                                        width: "58%",
                                        display: "inline",
                                        float: "left",
                                    }}
                                >
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>General Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Date:</b>&nbsp;
                                            {report.date ? report.date : "N/A"}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Job Address:</b>&nbsp;
                                            {rT(
                                                "job_location",
                                                report.job_location
                                            )}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Client: </b>&nbsp;
                                            {rT(
                                                "client_name",
                                                report.client_name
                                            )}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)}>
                                            <b>Contact Details:</b>&nbsp;
                                            {rT(
                                                "client_contact",
                                                report.client_contact
                                            )}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>TTM Designer </b>&nbsp;
                                            {rT(
                                                "ttm_designer",
                                                report.ttm_designer
                                            )}
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13)}>
                                            <b>PSDP </b>&nbsp;
                                            {rT("psdp", report.psdp)}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Contractor: </b>&nbsp;
                                            {rT(
                                                "contractor_name",
                                                report.contractor_name
                                            )}
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13)}>
                                            <b>PSCS: </b>&nbsp;
                                            {rT("pscs", report.pscs)}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 7)}>
                                            <b>Auditor Name: </b>&nbsp;{" "}
                                            {rT(
                                                report.ins_name
                                                    ? "ins_name"
                                                    : "insp_name",
                                                report.ins_name
                                                    ? report.ins_name
                                                    : report.insp_name
                                            )}
                                        </div>
                                        <div style={cstyle(6, 7, 6, 13)}>
                                            <b>Auditor Contact: </b>&nbsp;
                                            {rT(
                                                report.ins_contact
                                                    ? "ins_contact"
                                                    : "insp_contact",
                                                report.ins_contact
                                                    ? report.ins_contact
                                                    : report.insp_contact
                                            )}
                                        </div>
                                        <div style={cstyle(8, 1, 8, 7)}>
                                            <b>Carriageway Detail:</b>&nbsp;
                                            {rC(
                                                "carriageway",
                                                report.carriageway_details
                                            )}
                                        </div>
                                        <div style={cstyle(8, 7, 8, 13)}>
                                            <b>Hardshoulder Used: </b>&nbsp;
                                            {rYN(
                                                "hardshoulder",
                                                report.hardshoulder
                                            )}
                                        </div>
                                        <div style={cstyle(9, 1, 9, 7)}>
                                            <b>Phase:</b>&nbsp;{" "}
                                            {rT("phase", report.phase)}
                                        </div>
                                        <div style={cstyle(9, 7, 9, 13)}>
                                            <b>Project: </b>&nbsp;{" "}
                                            {report.project === " " ||
                                            typeof report.project ===
                                                "undefined"
                                                ? rT(
                                                      "project",
                                                      report.project_num
                                                  )
                                                : rT("project", report.project)}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 7)}>
                                            <b>Job Number:</b>&nbsp;{" "}
                                            {rT("job_num", report.job_num)}
                                        </div>
                                        <div style={cstyle(7, 7, 7, 13)}>
                                            <b>Contract Number: </b>&nbsp;{" "}
                                            {rT(
                                                "contract_num",
                                                report.contract_num
                                            )}
                                        </div>
                                        <div style={cstyle(10, 1, 10, 7)}>
                                            <b>Road Number: </b>&nbsp;{" "}
                                            {rT(
                                                "road_number",
                                                report.road_number
                                            )}
                                        </div>
                                        <div style={cstyle(10, 7, 10, 13)}>
                                            <b>Speed Limit: </b>&nbsp;
                                            {rT(
                                                "speed_limit",
                                                report.speed_limit
                                            )}
                                        </div>
                                        <div style={cstyle(11, 1, 11, 7)}>
                                            <b>Roadworks Duration: </b>&nbsp;{" "}
                                            {rT(
                                                "roadworks_dur",
                                                report.roadworks_dur
                                            )}
                                        </div>
                                        <div style={cstyle(11, 7, 11, 13)}>
                                            <b>Time: </b>&nbsp;{" "}
                                            {report.time ? report.time : "N/A"}
                                        </div>
                                    </div>
                                </div>

                                {/* <div style={{border:"10px",borderRadius:"10px",borderColor:"#0188cc"}}
                                         
                                        >
                                            <b>Inspection Overview</b> */}

                                <div
                                    style={{
                                        float: "right",
                                        width: "40%",
                                        border: "3px solid #0188cc",
                                        borderRadius: "4px",
                                        height: "506px",
                                        // this.infoDiv === undefined
                                        //     ? 0
                                        //     : this.infoDiv.offsetHeight -
                                        //       10,
                                    }}
                                >
                                    <p
                                        style={{
                                            backgroundColor: "#0188cc",
                                            color: "white",
                                            paddingTop: "10px",
                                            paddingBottom: "9px",
                                            fontFamily: "Arial",
                                            paddingLeft: "10px",
                                        }}
                                    >
                                        Inspection Overview
                                    </p>
                                    <div style={{ marginLeft: "40px" }}>
                                        <Chart
                                            // float="right"
                                            // border = {"10px"}
                                            // borderRadius = {"10px"}
                                            // borderColor = {"#0188cc"}
                                            width={"440px"}
                                            height={"300px"}
                                            chartType="PieChart"
                                            loader={<div>Loading Chart</div>}
                                            data={[
                                                ["Color", "Count"],
                                                [
                                                    "Acceptable",
                                                    this.getTotal("A"),
                                                ],
                                                [
                                                    "Improvements Required",
                                                    this.getTotal("I"),
                                                ],
                                                [
                                                    "Unacceptable",
                                                    this.getTotal("U"),
                                                ],
                                                ["N/R", this.getTotal("N/R")],
                                            ]}
                                            options={{
                                                slices: {
                                                    0: { color: "green" },
                                                    1: { color: "#FFBF00" },
                                                    2: { color: "red" },
                                                    3: { color: "grey" },
                                                },
                                            }}
                                            rootProps={{ "data-testid": "1" }}
                                        />
                                    </div>
                                    <div style={{ marginLeft: "40px" }}>
                                        <FiberManualRecordIcon
                                            style={{ color: "green" }}
                                        />{" "}
                                        <b>Acceptable</b>{" "}
                                        <span style={{ marginLeft: "200px" }}>
                                            {" "}
                                            {this.getTotal("A")}
                                        </span>
                                        <br />
                                        <FiberManualRecordIcon
                                            style={{ color: "#FFBF00" }}
                                        />{" "}
                                        <b>Improvements Required</b>{" "}
                                        <span style={{ marginLeft: "103px" }}>
                                            {" "}
                                            {this.getTotal("I")}{" "}
                                        </span>{" "}
                                        <br />
                                        <FiberManualRecordIcon
                                            style={{ color: "red" }}
                                        />{" "}
                                        <b>Unacceptable</b>{" "}
                                        <span style={{ marginLeft: "181px" }}>
                                            {" "}
                                            {this.getTotal("U")}
                                            <br />{" "}
                                        </span>
                                        <FiberManualRecordIcon
                                            style={{ color: "grey" }}
                                        />{" "}
                                        <b>N/R </b>{" "}
                                        <span style={{ marginLeft: "260px" }}>
                                            {" "}
                                            {this.getTotal("N/R")}{" "}
                                        </span>
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(4, 4)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Inspection Map View</b>
                                    </div>
                                    <MapDiv>
                                        <MapWrapper
                                            start={{
                                                latitude: report.location_lat,
                                                longitude: report.location_lon,
                                            }}
                                            notes={
                                                report["attached_notes"] || []
                                            }
                                        />
                                    </MapDiv>
                                </div>
                            </div>
                            <br />
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(4, 4)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Works Description</b>
                                    </div>

                                    <div style={cstyle(2, 1, 4, 4, true)}>
                                        {report.work_desc === " " ||
                                        typeof report.work_desc === "undefined"
                                            ? rT("work_desc", report.works_desc)
                                            : rT("work_desc", report.work_desc)}
                                    </div>
                                </div>
                            </div>

                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(4, 4)}>
                                    <div
                                        style={cstyle(1, 1, 1, 4, false, true)}
                                    >
                                        <b>Rating Details</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 1)}>
                                        <b>Rating:</b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 2)}>
                                        <b>Colour Code:</b>
                                    </div>
                                    <div style={cstyle(2, 3, 2, 4)}>
                                        <b>Definition:</b>
                                    </div>
                                    <div style={cstyle(3, 1, 3, 1)}>
                                        Acceptable
                                    </div>
                                    <div style={cstyle(3, 2, 3, 2)}>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: "green",
                                                marginLeft: "75px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(3, 3, 3, 4)}>
                                        TTM operating safely and in accordance
                                        with required standard
                                    </div>
                                    <div style={cstyle(4, 1, 4, 1)}>
                                        Improvements Required
                                    </div>
                                    <div style={cstyle(4, 2, 4, 2)}>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: "#FFBF00",
                                                marginLeft: "75px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(4, 3, 4, 4)}>
                                        Minor Non conformance requires
                                        improvement
                                    </div>
                                    <div style={cstyle(5, 1, 5, 1)}>
                                        Unacceptable
                                    </div>
                                    <div style={cstyle(5, 2, 5, 2)}>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: "red",
                                                marginLeft: "75px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(5, 3, 5, 4)}>
                                        Major Non conformance, TTM requires
                                        immediate corrective action
                                    </div>
                                    <div style={cstyle(6, 1, 6, 1)}>
                                        Not Reviewed
                                    </div>
                                    <div style={cstyle(6, 2, 6, 2)}>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: "grey",
                                                marginLeft: "75px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(6, 3, 6, 4)}>
                                        Item not reviewed or not applicable to
                                        the site inspected
                                    </div>
                                </div>
                            </div>

                            {Object.keys(checks).map((e) => {
                                let checkRowCount = 2;
                                return (
                                    <div
                                        style={{ width: "100%", clear: "both" }}
                                    >
                                        <div
                                            style={gstyle(
                                                checks[e].length + 3,
                                                5,
                                                null
                                            )}
                                        >
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    5,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>{e}</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    1,
                                                    2,
                                                    1,
                                                    false
                                                )}
                                            >
                                                <b>No</b>{" "}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    2,
                                                    2,
                                                    4,
                                                    false
                                                )}
                                            >
                                                <b>Inspection Measure</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    4,
                                                    2,
                                                    5,
                                                    false
                                                )}
                                            >
                                                <b>Status</b>
                                            </div>

                                            {checks[e].map((f) => {
                                                checkRowCount++;
                                                return (
                                                    <React.Fragment
                                                        key={checkRowCount}
                                                    >
                                                        <div
                                                            style={cellStyle(
                                                                checkRowCount,
                                                                1,
                                                                checkRowCount,
                                                                2
                                                            )}
                                                        >
                                                            {prefix +
                                                                "." +
                                                                f.id}
                                                        </div>
                                                        <div
                                                            style={cellStyle(
                                                                checkRowCount,
                                                                2,
                                                                checkRowCount,
                                                                4
                                                            )}
                                                        >
                                                            {" "}
                                                            {f.question}
                                                        </div>
                                                        <div
                                                            style={cellStyle(
                                                                checkRowCount,
                                                                4,
                                                                checkRowCount,
                                                                5,
                                                                true
                                                            )}
                                                        >
                                                            {rI(
                                                                f.key,
                                                                report[f.key]
                                                            )}
                                                        </div>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(12, 2)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Inspection/Audit Results</b>
                                    </div>

                                    <div style={cstyle(2, 1, 4, 2, true)}>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: "green",
                                                marginLeft: "75px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(2, 2, 4, 4, true)}>
                                        {count("A")}
                                    </div>
                                    <div style={cstyle(2, 4, 4, 6, true)}>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: "red",
                                                marginLeft: "75px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(2, 6, 4, 8, true)}>
                                        {count("U")}
                                    </div>
                                    <div style={cstyle(2, 8, 4, 10, true)}>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: "#FFBF00",
                                                marginLeft: "75px",
                                            }}
                                        />
                                    </div>
                                    <div style={cstyle(2, 10, 4, 12, true)}>
                                        {count("I")}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(12, 2)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Additional Notes</b>
                                    </div>

                                    <div style={cstyle(2, 1, 4, 2, true)}>
                                        Ref
                                    </div>
                                    <div style={cstyle(2, 2, 4, 4, true)}>
                                        Rating
                                    </div>
                                    <div style={cstyle(2, 4, 4, 6, true)}>
                                        Comment
                                    </div>
                                    <div style={cstyle(2, 6, 4, 8, true)}>
                                        Time In
                                    </div>
                                    <div style={cstyle(2, 8, 4, 10, true)}>
                                        Time Out
                                    </div>
                                    <div style={cstyle(2, 10, 4, 12, true)}>
                                        Action
                                    </div>
                                    {report.attached_notes &&
                                        report.attached_notes.map((f) => {
                                            noteCount++;
                                            return (
                                                <React.Fragment key={noteCount}>
                                                    <div
                                                        style={cellStyle(
                                                            noteCount,
                                                            1,
                                                            noteCount,
                                                            2
                                                        )}
                                                    >
                                                        {f.ref}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            noteCount,
                                                            2,
                                                            noteCount,
                                                            4
                                                        )}
                                                    >
                                                        {f.ref_rating}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            noteCount,
                                                            4,
                                                            noteCount,
                                                            6,
                                                            true
                                                        )}
                                                    >
                                                        {f.comment}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            noteCount,
                                                            6,
                                                            noteCount,
                                                            8,
                                                            true
                                                        )}
                                                    >
                                                        {f.time_recorded_in}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            noteCount,
                                                            8,
                                                            noteCount,
                                                            10,
                                                            true
                                                        )}
                                                    >
                                                        {f.time_recorded_out}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            noteCount,
                                                            10,
                                                            noteCount,
                                                            12,
                                                            true
                                                        )}
                                                    >
                                                        <img
                                                            style={{
                                                                width: "100px",
                                                                height: "100px",
                                                            }}
                                                            src={f.photo_url}
                                                            onClick={() =>
                                                                this.setState({
                                                                    selectedImg:
                                                                        f.photo_url,
                                                                    imageModal: true,
                                                                })
                                                            }
                                                            alt="site"
                                                        />
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.editing && checkedit === "report-edit-jobpack" && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-edit-jobpack",
                                "report-view"
                            )}
                        >
                            <div>
                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        this.props.setReport(
                                            this.state.report,
                                            this.props.location.pathname,
                                            reportType
                                        );
                                        this.props.setActivity(
                                            "update",
                                            "report",
                                            this.state.reportType
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                                <Button color="primary" variant="contained">
                                    Cancel
                                </Button>
                            </div>
                        </Link>
                    )}
                    {!this.state.editing && checkedit === "report-view" && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-view",
                                "report-edit-jobpack"
                            )}
                        >
                            <Button variant="contained">Edit</Button>
                        </Link>
                    )}

                    {this.state.editing && checkedit === "report-edit" && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-edit",
                                "report-view-standalone"
                            )}
                        >
                            <div>
                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        this.props.setReport(
                                            this.state.report,
                                            this.props.location.pathname,
                                            reportType
                                        );
                                        this.props.setActivity(
                                            "update",
                                            "report",
                                            this.state.reportType
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                                <Button color="primary" variant="contained">
                                    Cancel
                                </Button>
                            </div>
                        </Link>
                    )}
                    {!this.state.editing &&
                        checkedit === "report-view-standalone" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view-standalone",
                                    "report-edit"
                                )}
                            >
                                <Button variant="contained">Edit</Button>
                            </Link>
                        )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Additional Notes Image</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                        selectedImg === null ||
                                        selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, setActivity, getJobPackReport }
)(HD16Inspection);
